import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const PallavBhatt = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "team-images/pallav-bhatt.JPG" }) {
          childImageSharp {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} />}
  />
)
export default PallavBhatt
